// removed by extract-text-webpack-plugin
module.exports = {"index-table":"index-table___aL4KY","index-title":"index-title___3IyuY","index-subtitle":"index-subtitle___3LMzL","index-grade-wrap":"index-grade-wrap___32k6r","index-grade-wrap-1":"index-grade-wrap-1___2gTwe","index-grade-wrap-2":"index-grade-wrap-2___7ZaP5","index-grade-wrap-3":"index-grade-wrap-3___11cXd","index-grade-wrap-4":"index-grade-wrap-4___3-3mY","index-grade-wrap-5":"index-grade-wrap-5___2Ihdy","index-link":"index-link___Fi3XM"};


//////////////////
// WEBPACK FOOTER
// ./src/core/BenchmarkGridTable/BenchmarkGridTable.css
// module id = 915
// module chunks = 0